import React, { useState } from 'react';

const SignupPage = () => {
  const [email, setEmail] = useState('');
  const [gender, setGender] = useState('');
  const [isGenderDropdownOpen, setIsGenderDropdownOpen] = useState(false);
  
  const genderOptions = ['Male', 'Female', 'Non-binary', 'Prefer not to say'];
  
  return (
    <div className="flex flex-col min-h-screen bg-gray-100">
      {/* Hero section with signup */}
      <div className="bg-black text-white py-24 px-4">
        <div className=" mx-auto flex flex-col items-center">
          <h1 className="text-3xl md:text-4xl font-bold text-center mb-6">
            Sign up to receive 20% off your next order*
          </h1>
          
          <p className="text-center mb-8">
            Get the inside hook ups you deserve with discounts, exclusive drops and first dibs on party invites.
          </p>
          
          <div className="w-full flex flex-col md:flex-row gap-4 justify-center items-center">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              className="w-full md:w-64 px-4 py-2 border-b border-gray-600 bg-transparent focus:outline-none"
            />
            
            <div className="relative w-full md:w-64">
              <button
                onClick={() => setIsGenderDropdownOpen(!isGenderDropdownOpen)}
                className="w-full flex justify-between items-center px-4 py-2 border-b border-gray-600 bg-transparent text-white"
              >
                {gender || 'Gender'}
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
              
              {isGenderDropdownOpen && (
                <div className="absolute z-10 w-full mt-1 bg-gray-800 rounded shadow-lg">
                  {genderOptions.map((option) => (
                    <div
                      key={option}
                      className="px-4 py-2 hover:bg-gray-700 cursor-pointer"
                      onClick={() => {
                        setGender(option);
                        setIsGenderDropdownOpen(false);
                      }}
                    >
                      {option}
                    </div>
                  ))}
                </div>
              )}
            </div>
            
            <button className="w-full md:w-auto px-8 py-2 bg-purple-500 hover:bg-purple-600 text-white font-medium rounded">
              JOIN
            </button>
          </div>
        </div>
      </div>
      
      {/* Features section */}
      <div className="py-28 px-4 bg-gray-100">
        <div className=" mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Delivery Feature */}
            <div className="flex flex-col items-center text-center">
              <div className=" mb-4">
               <img src="/assets/Services.svg" alt="delivery" />
              </div>
              <h3 className="text-lg font-bold uppercase mb-2">FREE AND FAST DELIVERY</h3>
              <p className="text-sm">Free delivery for all orders over $140</p>
            </div>
            
            {/* Customer Service Feature */}
            <div className="flex flex-col items-center text-center">
              <div className=" mb-4">
                <img src="/assets/Services (1).svg" alt="delivery" />
              </div>
              <h3 className="text-lg font-bold uppercase mb-2">24/7 CUSTOMER SERVICE</h3>
              <p className="text-sm">Friendly 24/7 customer support</p>
            </div>
            
            {/* Money Back Feature */}
            <div className="flex flex-col items-center text-center">
              <div className=" mb-4">
                <img src="/assets/Services (2).svg" alt="delivery" />
              </div>
              <h3 className="text-lg font-bold uppercase mb-2">MONEY BACK GUARANTEE</h3>
              <p className="text-sm">We return money within 30 days</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupPage;